import React, { useState } from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';

interface LazyRenderProps {
  children: React.ReactNode;
  options?: IntersectionObserverInit;
}

/*
 * Renders children when the component comes into view.
 * This component uses the intersection observer and accepts optional `IntersectionObserverInit` parameters
 * as the `options` prop.
 *
 * Example:
 * ```ts
 * <LazyRender
 *   options={{
 *     // render the child 200px before the component is in view
       rootMargin: '200px',
     }}>
 *     <ExpensiveDataFetchingComponent/>
 * </LazyRender>
 * ```
 */
export const LazyRender = ({ children, options }: LazyRenderProps) => {
  const [renderChildren, setRenderChildren] = useState(false);

  const impressionRef = useImpressionRef<HTMLDivElement>(() => {
    setRenderChildren(true);
  }, options);

  return <div ref={impressionRef}>{renderChildren ? children : null}</div>;
};
